"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import $ from "jquery";
import _ from "underscore";
import ApiService from "../services/api_service";
import ObjectWithIDStore from "../stores/object_with_id_store";
var deferred = $.Deferred();
var store = new ObjectWithIDStore();
var unknownContact = {
  id: "",
  name: "Unknown Contact",
  email: ""
};
function clean(name) {
  if (_.isNull(name)) {
    name = "";
  }
  return name.toLowerCase().replace(/[& -]/g, "");
}
function fetchAndStoreDataSince(date) {
  return ApiService.addErrorHandler(
    // TODO: use fetch instead
    // eslint-disable-next-line no-restricted-syntax
    $.get("/api/contacts?since=" + date.getTime()).done(function(data) {
      if (data.contacts.length > 0) {
        _.each(data.contacts, function(item) {
          store.addOrUpdate(item);
        });
      }
    }),
    "Failed to load contacts. Please refresh.",
    { caller: "ContactService.fetchAndStoreDataSince" }
  );
}
class ContactService {
  constructor() {
    __publicField(this, "contactService", {
      store,
      contacts: function() {
        return _.sortBy(store.items, this.contactSort);
      },
      getContact: function(id) {
        return store.index[id];
      },
      contactWithId: function(contactId) {
        return store.index[contactId] || unknownContact;
      },
      filterByEmailOrName: function(term) {
        return _.select(_.sortBy(store.items, this.contactSort), function(x) {
          return clean(x.name).indexOf(clean(term)) >= 0 || clean(x.email).indexOf(clean(term)) >= 0;
        });
      },
      contactSort: function(contact) {
        if (contact.id === "") {
          return "A";
        } else {
          return contact.email;
        }
      },
      updateContact: function(contact) {
        store.addOrUpdate(contact);
        $(this).trigger("contact_service:updated");
        return contact;
      },
      destroyContact: function(contact) {
        store.destroy(contact);
        $(this).trigger("contact_service:updated");
        return contact;
      }
    });
    __publicField(this, "ready", _.once(() => {
      this.loadContacts(deferred);
      return deferred.promise();
    }));
  }
  loadContacts(deferred2) {
    fetchAndStoreDataSince(/* @__PURE__ */ new Date(0)).then(() => {
      deferred2.resolve(this.contactService);
    });
  }
}
var contactService = new ContactService();
export default contactService;
